import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../Context/AuthContext";
import CartPopup from "../sharedComponents/CartPopup";
import Loading from "./Loading";
import Popup from "../sharedComponents/Popup";
import axios from "axios";
function SideButton({ islogin }) {
  // const [isLoading, setIsLoading] =useState(false)
  const [expanded, setExpanded] = useState(false);
  const locationObj = useLocation();
  const { myAuth, logout, checkExpiration } = useContext(AuthContext);

  const [cartlength, setCartLength] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [sideForPc, setSideForPc] = useState({});
  const [sideForMb, setSideForMb] = useState({});

  const navigate = useNavigate();
  const selectedOption = useSelector((state) => state.product.productId);
  //判斷網址
  const location = useLocation();
  const currentPath = location.pathname;
  // console.log("currentPath", currentPath);
  // console.log("購物車有新資料", selectedOption);
  const getSideInfo = () => {
    axios
      .get("/api/Home/SidebarNav", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const responseData = response.data;
        console.log("回傳的SidebarNav", "responseData");
        setSideForPc(responseData.sidebarNavForPC);
        setSideForMb(responseData.sidebarNavForMobile);
      })
      .catch((error) => {
        console.error("SidebarNav有錯誤：", "error");
        console.error(
          "寄送SidebarNav出現的錯誤訊息",
          "error.response.data.message"
        );
      });
  };

  const handlePhoneButtonClick = () => {
    setExpanded(!expanded);
  };

  const handleLoginClick = () => {
    // 将当前页面的URL存储到Session Storage中
    sessionStorage.setItem("prevPath", locationObj.pathname);
  };
  const handleCartPopup = () => {
    // if (currentPath !== "/checkout") {
    //   setIsPopupOpen(true);
    // }
    setIsPopupOpen(true);
  };
  useEffect(() => {
    getSideInfo();
  }, []);


  useEffect(() => {
    setExpanded(false);
    setIsPopupOpen(false);
  }, [locationObj]);

  const storedToken = localStorage.getItem("userToken");
  const storeduserMid = localStorage.getItem("userMid");
  useEffect(() => {
    const fetchData = async () => {
      if (myAuth.authorized) {
        await checkExpiration();
  
        try {
          const cartAmount = myAuth.cartamount; // 可能需要修改取得 cartamount 的方式
          setCartLength(cartAmount);
        } catch (error) {
          // 處理錯誤
          console.error("Error fetching cart data:", "error");
          if (error.response && error.response.status === 401) {
            // 如果是 401，觸發 logout()
            logout();
          }
        }
      }
    };
  
    fetchData();
  }, [myAuth.authorized, isPopupOpen]);
  useEffect(() => {
    if (myAuth.authorized !== null) {
      if (myAuth.authorized) {
        console.log("myAuth.cartamount", "myAuth.cartamount");
        setCartLength(myAuth.cartamount);
      } else {
        const cartData = localStorage.getItem("cart");
        const cartArray = cartData ? JSON.parse(cartData) : [];
        setCartLength(cartArray.length);
        console.log("cartlength", cartlength);
      }
      getSideInfo();
    }
  }, [selectedOption, myAuth.authorized, myAuth.cartamount, myAuth.cartData]);
  //重複的側邊按鈕
  const PcLoginButton = (key, icon, navname, navurl, blank) => {
    return (
      <Link
        to={`${navurl}`}
        className="side-button"
        onClick={handleLoginClick}
        key={key}
        {...(blank && {
          replace: false,
          target: "_blank"  
        })}
      >
        <div className="wrap">
          <div className="wrap-svg">
            <img src={icon} alt={navname} title={navname} />
          </div>
          <div className="wrap-text">
            <div>
              <h4 className="h4 primary-deep3">{navname}</h4>
            </div>
          </div>
        </div>
      </Link>
    );
  };
  const PcCartButton = (key, icon, navname, navurl, blank) => {
    return (
      <Link
      to={"/cart"}
            className={`side-button`}

        // className={`side-button ${currentPath === "/checkout" || currentPath === "/checkoutnotauth" ? "d-none" : ""}`}
        // onClick={handleCartPopup}
        key={key}
      >
        <div className="wrap">
          <div className="wrap-svg">
            <img src={icon} alt={navname} title={navname} />
            <div className="cart-amouunt">{cartlength}</div>
          </div>
          <div className="wrap-text">
            <div>
              <h4 className="h4 primary-deep3">{navname}</h4>
            </div>
          </div>
        </div>
      </Link>
    );
  };
  const PcLinkButton = (key, icon, navname, navurl, blank) => {
    return (
      <Link to={`${navurl}`} className="side-button" key={key}  {...(blank && {
        replace: false,
        target: "_blank"  
      })}>
        <div className="wrap">
          <div className="wrap-svg">
            <img src={icon} alt={navname} title={navname} />
          </div>
          <div className="wrap-text">
            <div>
              <h4 className="h4 primary-deep3">{navname}</h4>
            </div>
          </div>
        </div>
      </Link>
    );
  };
  const PcSwitchLogin = (key, icon) => {
    return (
      <Link
        to={myAuth.authorized ? "/" : "/login"}
        className="side-button"
        onClick={myAuth.authorized ? logout : null}
        key={key}
        
      >
        <div className="wrap">
          <div className="wrap-svg">
            <img
              src={icon}
              alt={myAuth.authorized ? "會員登出" : "會員登入"}
              title={myAuth.authorized ? "會員登出" : "會員登入"}
            />
          </div>
          <div className="wrap-text">
            <div>
              <h4 className="h4 primary-deep3">
                {myAuth.authorized ? "會員登出" : "會員登入"}
              </h4>
            </div>
          </div>
        </div>
      </Link>
    );
  };
  const MbSwitchLogin = (key, icon) => {
    return (
      <Link
        to={myAuth.authorized ? "/" : "/login"}
        className="phone-side-wrap"
        onClick={myAuth.authorized ? logout : null}
        key={key}
        
      >
        <div className="phone-side-text white">
          <h5>{myAuth.authorized ? "會員登出" : "會員登入"}</h5>
        </div>
        <div className="phone-side-button2">
          <img
            src={icon}
            alt={myAuth.authorized ? "會員登出" : "會員登入"}
            title={myAuth.authorized ? "會員登出" : "會員登入"}
          />
        </div>
      </Link>
    );
  };

  const MbLink = (key, icon, navname, navurl, blank) => {
    return (
      <Link to={navurl} className="phone-side-wrap" key={key}  {...(blank && {
        replace: false,
        target: "_blank"  
      })}>
        <div className="phone-side-text white">
          <h5>{navname}</h5>
        </div>
        <div className="phone-side-button2">
          <img src={icon} alt={navname} title={navname} />
        </div>
      </Link>
    );
  };

  const MbCart = (key, icon, navname) => {
    return (
      <Link
      to={"/cart"}
        className={`phone-side-wrap`}
        key={key}
        // onClick={handleCartPopup}
      >
        <div className="phone-side-text white">
          <h5>{navname}</h5>
        </div>
        <div className="phone-side-button2 cart-box">
          <img src={icon} alt={navname} title={navname} />
          <div className="cart-amouunt">
            <p className="p2 danger">{cartlength}</p>
          </div>
        </div>
      </Link>
    );
  };
  if (!sideForPc) {
    return <Loading />;
  }

  return (
    <>
      {/* {isPopupOpen && (
        <CartPopup
          onClose={() => {
            setIsPopupOpen(false);
            if (currentPath === "/checkout"){
              window.location.assign('/checkout');
              sessionStorage.removeItem("shopid");
              sessionStorage.removeItem("areatype");
            }
            if(currentPath === "/checkoutnotauth"){
              window.location.assign('/checkout');
              sessionStorage.removeItem("shopid");
              sessionStorage.removeItem("areatype");
            }
          }}
          onNevigate={() => {
            setIsPopupOpen(false);
            
            if (currentPath === "/checkout"){
              window.location.assign('/checkout');
              sessionStorage.removeItem("shopid");
              sessionStorage.removeItem("areatype");
              
            }else if(currentPath === "/checkoutnotauth"){
              window.location.assign('/checkout');
              sessionStorage.removeItem("shopid");
              sessionStorage.removeItem("areatype");
            }else{
              if(myAuth.authorized){
                navigate("/checkout");
              }else{
                navigate("/checkoutstep1");
              }
            }
          }}
        />
      )} */}

      <div
        className={`${expanded ? "phone-side-expand" : ""}`}
        onClick={() => {
          if (expanded) {
            setExpanded(false);
          }
        }}
      >
        <div className="side-button-container d-none d-xxl-flex">
          {sideForPc &&
            Object.values(sideForPc).map(
              (item, index) =>
                item.navcate === "b"
                  ? PcLoginButton(index, item.icon, item.navname, item.navurl, item.blank)
                  : item.navcate === "f"
                  ? PcCartButton(index, item.icon, item.navname)
                  : item.navcate === "c"
                  ? PcLinkButton(index, item.icon, item.navname, item.navurl, item.blank)
                  : item.navcate === "d"
                  ? PcLinkButton(index, item.icon, item.navname, item.navurl, item.blank)
                  : item.navcate === "e"
                  ? PcLinkButton(index, item.icon, item.navname, item.navurl, item.blank)
                  : item.navcate === "g"
                  ? PcSwitchLogin(index, item.icon)
                  : null // 必须返回一个元素
            )}
        </div>
       

        <div className="phone-side-button-container d-flex d-xxl-none">
          {expanded ? (
            <>
              {sideForMb &&
                Object.values(sideForMb).map(
                  (item, index) =>
                    item.navcate === "g"
                      ? MbSwitchLogin(index, item.icon)
                      : item.navcate === "b"
                      ? MbLink(index, item.icon, item.navname, item.navurl ,item.blank)
                      : item.navcate === "c"
                      ? MbLink(index, item.icon, item.navname, item.navurl ,item.blank)
                      : item.navcate === "d"
                      ? MbLink(index, item.icon, item.navname, item.navurl ,item.blank)
                      : item.navcate === "e"
                      ? MbLink(index, item.icon, item.navname, item.navurl ,item.blank)
                      : item.navcate === "f"
                      ? MbCart(index, item.icon, item.navname)
                      : null // 必须返回一个元素
                )}
              
            </>
          ) : (
            <></>
          )}
          <div className="phone-side-button" onClick={handlePhoneButtonClick}>
            {expanded ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                className="cross"
              >
                <path
                  d="M20 24.2586L5.09506 39.1635C4.53739 39.7212 3.82763 40 2.96578 40C2.10393 40 1.39417 39.7212 0.836501 39.1635C0.278833 38.6058 0 37.8961 0 37.0342C0 36.1724 0.278833 35.4626 0.836501 34.9049L15.7414 20L0.836501 5.09506C0.278833 4.53739 0 3.82763 0 2.96578C0 2.10393 0.278833 1.39417 0.836501 0.836501C1.39417 0.278833 2.10393 0 2.96578 0C3.82763 0 4.53739 0.278833 5.09506 0.836501L20 15.7414L34.9049 0.836501C35.4626 0.278833 36.1724 0 37.0342 0C37.8961 0 38.6058 0.278833 39.1635 0.836501C39.7212 1.39417 40 2.10393 40 2.96578C40 3.82763 39.7212 4.53739 39.1635 5.09506L24.2586 20L39.1635 34.9049C39.7212 35.4626 40 36.1724 40 37.0342C40 37.8961 39.7212 38.6058 39.1635 39.1635C38.6058 39.7212 37.8961 40 37.0342 40C36.1724 40 35.4626 39.7212 34.9049 39.1635L20 24.2586Z"
                  fill="#00692E"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="41"
                viewBox="0 0 40 41"
                fill="none"
                
              >
                <path
                  d="M24.2969 15.8334V22.1849C24.2969 22.349 24.1719 22.474 24.0078 22.474H22.9922C22.8906 22.474 22.8047 22.4193 22.7578 22.3568L19.8438 18.4271V22.1928C19.8438 22.3568 19.7188 22.4818 19.5547 22.4818H18.5391C18.375 22.4818 18.25 22.3568 18.25 22.1928V15.8412C18.25 15.6771 18.375 15.5521 18.5391 15.5521H19.5469C19.6328 15.5521 19.7344 15.599 19.7812 15.6771L22.6953 19.6068V15.8412C22.6953 15.6771 22.8203 15.5521 22.9844 15.5521H24C24.1641 15.5443 24.2969 15.6771 24.2969 15.8256V15.8334ZM16.9766 15.5443H15.9609C15.7969 15.5443 15.6719 15.6693 15.6719 15.8334V22.1849C15.6719 22.349 15.7969 22.474 15.9609 22.474H16.9766C17.1406 22.474 17.2656 22.349 17.2656 22.1849V15.8334C17.2656 15.6849 17.1406 15.5443 16.9766 15.5443ZM14.5234 20.8646H11.7422V15.8334C11.7422 15.6693 11.6172 15.5443 11.4531 15.5443H10.4375C10.2734 15.5443 10.1484 15.6693 10.1484 15.8334V22.1849C10.1484 22.2631 10.1719 22.3256 10.2266 22.3802C10.2813 22.4271 10.3438 22.4584 10.4219 22.4584H14.5C14.6641 22.4584 14.7891 22.3334 14.7891 22.1693V21.1537C14.7891 21.0052 14.6641 20.8646 14.5156 20.8646H14.5234ZM29.6562 15.5443H25.5703C25.4219 15.5443 25.2812 15.6693 25.2812 15.8334V22.1849C25.2812 22.3334 25.4062 22.474 25.5703 22.474H29.6484C29.8125 22.474 29.9375 22.349 29.9375 22.1849V21.1615C29.9375 20.9974 29.8125 20.8724 29.6484 20.8724H26.875V19.8099H29.6484C29.8125 19.8099 29.9375 19.6849 29.9375 19.5209V18.4974C29.9375 18.3334 29.8125 18.2084 29.6484 18.2084H26.875V17.1381H29.6484C29.8125 17.1381 29.9375 17.0131 29.9375 16.849V15.8334C29.9297 15.6849 29.8047 15.5443 29.6484 15.5443H29.6562ZM40 7.75526V33.224C39.9922 37.224 36.7109 40.4662 32.7031 40.4584H7.23438C3.23439 40.4506 -0.00779841 37.1615 1.40894e-05 33.1615V7.69276C0.00782658 3.69276 3.29689 0.450576 7.29688 0.458388H32.7656C36.7656 0.466201 40.0078 3.74745 40 7.75526ZM34.5 18.7006C34.5 12.1849 27.9609 6.88026 19.9375 6.88026C11.9141 6.88026 5.37501 12.1849 5.37501 18.7006C5.37501 24.5365 10.5547 29.4349 17.5547 30.3646C19.2578 30.7318 19.0625 31.3568 18.6797 33.6537C18.6172 34.0209 18.3828 35.0912 19.9375 34.4427C21.4922 33.7943 28.3203 29.5052 31.3828 25.9896C33.4922 23.6693 34.5 21.3177 34.5 18.7162V18.7006Z"
                  fill="#00B900"
                />
              </svg>
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid bottom-section text-center d-xxl-none">
        <div className="row">
          <div className="col">
            <Link to="/allcollections">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.55556 0H1.22222C0.898069 0 0.587192 0.128769 0.357981 0.357981C0.128769 0.587192 0 0.898069 0 1.22222V8.55556C0 8.87971 0.128769 9.19059 0.357981 9.4198C0.587192 9.64901 0.898069 9.77778 1.22222 9.77778H8.55556C8.87971 9.77778 9.19059 9.64901 9.4198 9.4198C9.64901 9.19059 9.77778 8.87971 9.77778 8.55556V1.22222C9.77778 0.898069 9.64901 0.587192 9.4198 0.357981C9.19059 0.128769 8.87971 0 8.55556 0ZM7.33333 7.33333H2.44444V2.44444H7.33333V7.33333ZM20.7778 12.2222H13.4444C13.1203 12.2222 12.8094 12.351 12.5802 12.5802C12.351 12.8094 12.2222 13.1203 12.2222 13.4444V20.7778C12.2222 21.1019 12.351 21.4128 12.5802 21.642C12.8094 21.8712 13.1203 22 13.4444 22H20.7778C21.1019 22 21.4128 21.8712 21.642 21.642C21.8712 21.4128 22 21.1019 22 20.7778V13.4444C22 13.1203 21.8712 12.8094 21.642 12.5802C21.4128 12.351 21.1019 12.2222 20.7778 12.2222ZM19.5556 19.5556H14.6667V14.6667H19.5556V19.5556ZM17.1111 0C14.4149 0 12.2222 2.19267 12.2222 4.88889C12.2222 7.58511 14.4149 9.77778 17.1111 9.77778C19.8073 9.77778 22 7.58511 22 4.88889C22 2.19267 19.8073 0 17.1111 0ZM17.1111 7.33333C15.763 7.33333 14.6667 6.237 14.6667 4.88889C14.6667 3.54078 15.763 2.44444 17.1111 2.44444C18.4592 2.44444 19.5556 3.54078 19.5556 4.88889C19.5556 6.237 18.4592 7.33333 17.1111 7.33333ZM4.88889 12.2222C2.19267 12.2222 0 14.4149 0 17.1111C0 19.8073 2.19267 22 4.88889 22C7.58511 22 9.77778 19.8073 9.77778 17.1111C9.77778 14.4149 7.58511 12.2222 4.88889 12.2222ZM4.88889 19.5556C3.54078 19.5556 2.44444 18.4592 2.44444 17.1111C2.44444 15.763 3.54078 14.6667 4.88889 14.6667C6.237 14.6667 7.33333 15.763 7.33333 17.1111C7.33333 18.4592 6.237 19.5556 4.88889 19.5556Z"
                  fill="#00692E"
                />
              </svg>
              <p className="p-2">產品分類</p>
            </Link>
          </div>
          <div className="col">
            <Link to="/member/collection">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
              >
                <path
                  d="M12.0057 18L4.36699 11.5515C0.21554 7.68234 6.31817 0.253621 12.0057 6.26366C17.6931 0.253621 23.7681 7.70813 19.6443 11.5515L12.0057 18Z"
                  fill="#00692E"
                  stroke="#00692E"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="p-2">我的收藏</p>
            </Link>
          </div>
          <div className="col">
            <Link to="/member">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 11C9.4875 11 8.19271 10.4615 7.11562 9.38437C6.03854 8.30729 5.5 7.0125 5.5 5.5C5.5 3.9875 6.03854 2.69271 7.11562 1.61563C8.19271 0.538542 9.4875 0 11 0C12.5125 0 13.8073 0.538542 14.8844 1.61563C15.9615 2.69271 16.5 3.9875 16.5 5.5C16.5 7.0125 15.9615 8.30729 14.8844 9.38437C13.8073 10.4615 12.5125 11 11 11ZM0 22V18.15C0 17.3708 0.20075 16.6545 0.60225 16.0009C1.00375 15.3473 1.53633 14.8491 2.2 14.5063C3.62083 13.7958 5.06458 13.2628 6.53125 12.9071C7.99792 12.5515 9.4875 12.3741 11 12.375C12.5125 12.375 14.0021 12.5528 15.4687 12.9085C16.9354 13.2642 18.3792 13.7968 19.8 14.5063C20.4646 14.85 20.9976 15.3487 21.3991 16.0022C21.8006 16.6558 22.0009 17.3718 22 18.15V22H0Z"
                  fill="#00692E"
                />
              </svg>
              <p className="p-2">會員專區</p>
            </Link>
          </div>
          {/* <div className="col " onClick={handleCartPopup}>
            {currentPath === "/checkout" ? (
              <div className="d-flex flex-column align-items-center">
                <div className="cart-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.6763 4.97874C21.48 4.60616 21.1989 4.29567 20.8604 4.07756C20.522 3.85945 20.1376 3.74117 19.745 3.73424H5.20323L4.5443 0.921662C4.47773 0.650159 4.3292 0.411346 4.12291 0.24412C3.91661 0.0768932 3.66471 -0.00889416 3.40823 0.000729877H1.13608C0.83477 0.000729877 0.545804 0.131847 0.332749 0.365236C0.119693 0.598626 0 0.91517 0 1.24523C0 1.5753 0.119693 1.89184 0.332749 2.12523C0.545804 2.35862 0.83477 2.48974 1.13608 2.48974H2.54481L5.68038 15.2583C5.74695 15.5298 5.89548 15.7687 6.10177 15.9359C6.30807 16.1031 6.55997 16.1889 6.81645 16.1793H17.0411C17.2509 16.1786 17.4565 16.1143 17.6349 15.9934C17.8134 15.8726 17.9578 15.7 18.0522 15.4948L21.7786 7.33085C21.9401 6.96001 22.0153 6.55114 21.9974 6.14072C21.9796 5.73029 21.8693 5.3311 21.6763 4.97874ZM6.24879 22C7.18995 22 7.95291 21.1642 7.95291 20.1332C7.95291 19.1023 7.18995 18.2665 6.24879 18.2665C5.30764 18.2665 4.54468 19.1023 4.54468 20.1332C4.54468 21.1642 5.30764 22 6.24879 22ZM19.313 20.1332C19.313 21.1642 18.5501 22 17.6089 22C16.6677 22 15.9048 21.1642 15.9048 20.1332C15.9048 19.1023 16.6677 18.2665 17.6089 18.2665C18.5501 18.2665 19.313 19.1023 19.313 20.1332Z"
                      fill="#828282"
                    />
                  </svg>
                  <div className="cart-amouunt disabled">
                    <p className="p3 danger">{cartlength}</p>
                  </div>
                </div>
                <p className="p-2 disable">購物車</p>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center">
                <div className="cart-box">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.6763 4.97874C21.48 4.60616 21.1989 4.29567 20.8604 4.07756C20.522 3.85945 20.1376 3.74117 19.745 3.73424H5.20323L4.5443 0.921662C4.47773 0.650159 4.3292 0.411346 4.12291 0.24412C3.91661 0.0768932 3.66471 -0.00889416 3.40823 0.000729877H1.13608C0.83477 0.000729877 0.545804 0.131847 0.332749 0.365236C0.119693 0.598626 0 0.91517 0 1.24523C0 1.5753 0.119693 1.89184 0.332749 2.12523C0.545804 2.35862 0.83477 2.48974 1.13608 2.48974H2.54481L5.68038 15.2583C5.74695 15.5298 5.89548 15.7687 6.10177 15.9359C6.30807 16.1031 6.55997 16.1889 6.81645 16.1793H17.0411C17.2509 16.1786 17.4565 16.1143 17.6349 15.9934C17.8134 15.8726 17.9578 15.7 18.0522 15.4948L21.7786 7.33085C21.9401 6.96001 22.0153 6.55114 21.9974 6.14072C21.9796 5.73029 21.8693 5.3311 21.6763 4.97874ZM6.24879 22C7.18995 22 7.95291 21.1642 7.95291 20.1332C7.95291 19.1023 7.18995 18.2665 6.24879 18.2665C5.30764 18.2665 4.54468 19.1023 4.54468 20.1332C4.54468 21.1642 5.30764 22 6.24879 22ZM19.313 20.1332C19.313 21.1642 18.5501 22 17.6089 22C16.6677 22 15.9048 21.1642 15.9048 20.1332C15.9048 19.1023 16.6677 18.2665 17.6089 18.2665C18.5501 18.2665 19.313 19.1023 19.313 20.1332Z"
                      fill="#00692E"
                    />
                  </svg>
                  <div className="cart-amouunt">
                    <p className="p3 danger">{cartlength}</p>
                  </div>
                </div>

                <p className="p-2">購物車</p>
              </div>
            )}
          </div> */}
          <Link to="/cart" className="col " onClick={handleCartPopup}>

              <div className="d-flex flex-column align-items-center">
                <div className="cart-box">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.6763 4.97874C21.48 4.60616 21.1989 4.29567 20.8604 4.07756C20.522 3.85945 20.1376 3.74117 19.745 3.73424H5.20323L4.5443 0.921662C4.47773 0.650159 4.3292 0.411346 4.12291 0.24412C3.91661 0.0768932 3.66471 -0.00889416 3.40823 0.000729877H1.13608C0.83477 0.000729877 0.545804 0.131847 0.332749 0.365236C0.119693 0.598626 0 0.91517 0 1.24523C0 1.5753 0.119693 1.89184 0.332749 2.12523C0.545804 2.35862 0.83477 2.48974 1.13608 2.48974H2.54481L5.68038 15.2583C5.74695 15.5298 5.89548 15.7687 6.10177 15.9359C6.30807 16.1031 6.55997 16.1889 6.81645 16.1793H17.0411C17.2509 16.1786 17.4565 16.1143 17.6349 15.9934C17.8134 15.8726 17.9578 15.7 18.0522 15.4948L21.7786 7.33085C21.9401 6.96001 22.0153 6.55114 21.9974 6.14072C21.9796 5.73029 21.8693 5.3311 21.6763 4.97874ZM6.24879 22C7.18995 22 7.95291 21.1642 7.95291 20.1332C7.95291 19.1023 7.18995 18.2665 6.24879 18.2665C5.30764 18.2665 4.54468 19.1023 4.54468 20.1332C4.54468 21.1642 5.30764 22 6.24879 22ZM19.313 20.1332C19.313 21.1642 18.5501 22 17.6089 22C16.6677 22 15.9048 21.1642 15.9048 20.1332C15.9048 19.1023 16.6677 18.2665 17.6089 18.2665C18.5501 18.2665 19.313 19.1023 19.313 20.1332Z"
                      fill="#00692E"
                    />
                  </svg>
                  <div className="cart-amouunt">
                    <p className="p3 danger">{cartlength}</p>
                  </div>
                </div>

                <p className="p-2">購物車</p>
              </div>
           
          </Link> 
        </div>
      </div>
    </>
  );
}

export default SideButton;
